<template>
  <div class="post-info">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getList"
      >
        <el-option
          v-for="item in teamList"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span v-if="teamInfo">{{ teamInfo.captainName }}</span>
      </div>
    </div>

    <el-table class="list" :data="memberList">
      <el-table-column prop="avatar" label="队员头像" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 44px; height: 44px"
            :src="
              scope.row.avatar || require('@/assets/images/icons/icon_me.png')
            "
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="队员姓名" align="center">
      </el-table-column>
      <el-table-column prop="post" label="岗位名称" align="center">
      </el-table-column>
      <el-table-column prop="status" label="审核状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 'RESOLVE'" style="color: #6ce115"
            >已通过</span
          >
          <span v-if="scope.row.status == 'PENDING'" style="color: #ffc55f"
            >审核中</span
          >
          <span v-if="scope.row.status == 'REJECT'" style="color: #f56c6c"
            >已拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="加入日期" align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { teamList, memberList } from "@/api/team";

export default {
  data() {
    return {
      teamId: null,
      teamList: [],
      memberList: [],
    };
  },
  created() {
    this.getTeams();
  },
  computed: {
    teamInfo() {
      return this.teamId
        ? this.teamList.find((item) => item.teamId == this.teamId)
        : this.teamList[0];
    },
  },
  methods: {
    // 团队列表
    getTeams() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.teamList = res.data;
          if (this.teamList) this.teamId = this.teamList[0].teamId;

          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //   成员列表
    getList() {
      this.$loading.show();
      memberList({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.memberList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.post-info {
  text-align: left;
  .info-row {
    margin-bottom: 10px;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: #409eff;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>